var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VSnow',[(_vm.appErrorMessage)?_c('VErrorViewer',{attrs:{"message":_vm.appErrorMessage}}):_c('div',[_c('RouterView'),_c('VModalAlert'),_c('VModalConfirm'),_c('VModalSuccess'),_c('VModalError'),_c('VModalDanger')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }